// src/components/LatestProduct/LatesProduct.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useCurrency } from "../../components/PriceFormat/PriceFormat";
import { pickDisplayPrice, formatMoney } from "../../utils/pricePicker";
import { useTranslation } from "react-i18next";
import { loadProductsByLang } from "../../utils/productLoader";
const normalizeCurr = (c) => {
  const up = String(c || "TRY").toUpperCase();
  return up === "TL" ? "TRY" : up;
};

const isPerfume = (p) => {
  const c = p?.category;
  const has = (s) =>
    String(s || "")
      .toLowerCase()
      .includes("perfume") ||
    String(s || "")
      .toLowerCase()
      .includes("parfum") ||
    String(s || "")
      .toLowerCase()
      .includes("parfüm");
  if (Array.isArray(c)) return c.some(has);
  if (typeof c === "string") return has(c);
  return false;
};

// Parfüm için manual_prices öncelikli; değilse pickDisplayPrice
const pickPerfAwarePrice = (product, currency) => {
  const curr = normalizeCurr(currency);
  if (isPerfume(product)) {
    const mp = product?.manual_prices || product?.manualPrices;
    const v = mp?.[curr];
    if (v != null && !Number.isNaN(Number(v))) {
      return { amount: Number(v), curr };
    }
  }
  return pickDisplayPrice(product, curr); // mevcut akış
};

const LatesProduct = () => {
  const { t, i18n } = useTranslation();
  const [products, setProducts] = useState([]);
  const { currency } = useCurrency();

  useEffect(() => {
    let mounted = true;

    (async () => {
      try {
        // 1) EN ürünleri çek (mevcut sistem)
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/products`
        );
        const list = Array.isArray(res.data) ? res.data : [];

        // 2) TR/AR ise localized index hazırla
        const lang = (
          String(i18n?.language || "en").split("-")[0] || "en"
        ).toLowerCase();

        let localizedMap = new Map();
        if (lang !== "en") {
          try {
            const localized = await loadProductsByLang(lang); // /products-tr veya /products-ar
            localizedMap = new Map(
              (Array.isArray(localized) ? localized : []).map((p) => [
                p.stock_code || String(p.id),
                p,
              ])
            );
          } catch {
            localizedMap = new Map();
          }
        }

        // 3) Shuffle + ilk 4
        const arr = [...list];
        for (let i = arr.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [arr[i], arr[j]] = [arr[j], arr[i]];
        }
        const picked4 = arr.slice(0, 4);

        // 4) ✅ UI için localized override (api bozma yok)
        const merged = picked4.map((p) => {
          const key = p.stock_code || String(p.id);
          const loc = localizedMap.get(key);
          return loc ? { ...p, ...loc } : p;
        });

        if (mounted) setProducts(merged);
      } catch (err) {
        console.error("Ürünleri alırken hata oluştu:", err);
        if (mounted) setProducts([]);
      }
    })();

    return () => {
      mounted = false;
    };
  }, [i18n.language]);

  const getProductImage = (product) => {
    return (
      product?.default_images?.[0] ||
      product?.color_images?.[0]?.images?.[0] ||
      "https://apimukemel.com/api/assets/BTC0001-1.webp"
    );
  };

  const renderPrice = (product) => {
    const picked = pickPerfAwarePrice(product, currency);
    if (!picked) return null;

    const { amount, curr } = picked;
    const isTRY = curr === "TRY" || curr === "TL";
    const opts = isTRY
      ? amount < 1000
        ? { min: 1, max: 1 }
        : { min: 0, max: 0 }
      : { min: 0, max: 0 };

    return formatMoney(amount, curr, opts);
  };

  return (
    <>
      {products.map((product) => {
        const inStock = String(product?.availability || "")
          .toLowerCase()
          .includes("in stock");
        return (
          <div
            key={product.id}
            className="col-lg-3 col-md-6 col-sm-6 col-12 pe-0 px-0 mb-0 mt-0"
          >
            <a href={`/product/${product.id}`} className="text-decoration-none">
              <div className="cardbg">
                <img
                  src={getProductImage(product)}
                  className="d-block w-100"
                  alt={product.name}
                />
              </div>
              <div className="px-4 bg-light pt-2 pb-2">
                <h5 className="mb-0 text-dark">{product.name}</h5>
                {inStock ? (
                  <h6 className="text-muted mt-1">{renderPrice(product)}</h6>
                ) : (
                  <h6 className="fw-bold mt-1 text-danger">
                    {t("Out Of Stock")}
                  </h6>
                )}
              </div>
            </a>
          </div>
        );
      })}
    </>
  );
};

export default LatesProduct;
